import type { Odometer } from '@/api/generated/models';

export const NOT_AVAILABLE = 'N/A';

export function orNotAvailable(
  value: string | number | null | undefined,
): string {
  return value === null || value === undefined || value === ''
    ? NOT_AVAILABLE
    : String(value);
}

export function formatOdometer(odometer: Odometer): string {
  return `${odometer.value.toLocaleString()} ${odometer.unit}`;
}

export function formatQuantity(
  value: number | null | undefined,
  unit: string,
): string {
  return value === null || value === undefined
    ? NOT_AVAILABLE
    : `${value.toLocaleString()} ${unit}`;
}

export function formatMoney(money: {
  amount: number;
  currency: string;
}): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: money.currency,
  }).format(money.amount);
}
